const customXmlParts = {
    getByNamespaceAsync: function (ns, callback) {
        callback({ status: asyncResultStatus.Failed });
    }
}

const mockDocument = {
    url: "My Document.docx",
    customXmlParts,
    addHandlerAsync: (event, handler) => { console.log(`Added event handler for ${event}`) }
};

const mockContext = {
    document: mockDocument
};

const eventType = {
    DocumentSelectionChanged: "DocumentSelectionChanged"
}

const asyncResultStatus = {
    Succeeded: 'succeeded',
    Failed: 'failed'
}

class OfficeMock {
    constructor() {
        this.context = mockContext;
        this.EventType = eventType;
        this.AsyncResultStatus = asyncResultStatus
    }
}

export default OfficeMock